import IScheduleSendDetails from "./interfaces/ScheduleSendDetails.interface";

import { GiftCardSendTypeEnum } from "./enums/GiftCardSendTypeEnum";
import IBaseStepModel from "./interfaces/BaseStepModel.interface";
import {IRecipientDetails, RecipientDetailsModel} from "./RecipientDetails.model";
import {ISenderDetails, SenderDetailsModel } from "./SenderDetails.model";
import ScheduleSendDetailsModel from "./ScheduleSendDetails.model";
import { WorkflowTypeEnum } from "./enums/WorkflowTypeEnum";

export interface IRecipientsStep extends IBaseStepModel {
    sendBy: GiftCardSendTypeEnum;
    
    sendIndividually: boolean;
    senderSameAsRecipient: boolean; //visible only if recipients.length=1
    sendItLater: boolean;

    recipients: IRecipientDetails[];
    sender: ISenderDetails;
    scheduleSendDetails: IScheduleSendDetails;    
}

export class RecipientsStepModel implements IRecipientsStep, IBaseStepModel {
    sendBy: GiftCardSendTypeEnum;
    
    sendIndividually: boolean;
    senderSameAsRecipient: boolean; //visible only if recipients.length=1
    sendItLater: boolean;

    recipients: Array<IRecipientDetails>
    sender: ISenderDetails;
    scheduleSendDetails: IScheduleSendDetails; 
    
    isDirty: boolean;

    constructor(
    ) {
        //default by email
        this.sendBy = GiftCardSendTypeEnum.BY_EMAIL;
        this.sendIndividually = false;
        this.sendItLater = false;
        this.senderSameAsRecipient = false;

        this.recipients = new Array(0);
        this.sender = new SenderDetailsModel();

        //will be set later
        this.scheduleSendDetails = new ScheduleSendDetailsModel();
    }

    static parseModel(viewModel: IRecipientsStep): RecipientsStepModel {
        const model = new RecipientsStepModel();

        model.sendBy = viewModel.sendBy;
        model.senderSameAsRecipient = viewModel.senderSameAsRecipient;
        model.sendIndividually = viewModel.sendIndividually;
        model.sendItLater = viewModel.sendItLater;

        //objects
        model.recipients = [...viewModel.recipients];
        model.scheduleSendDetails = { ...viewModel.scheduleSendDetails };
        model.sender = { ...viewModel.sender };

        //sender
        //const sender = new SenderDetailsModel();
        //model.sender = new SenderDetailsModel();
        //model.sender.firstName = viewModel.sender.firstName;
        //model.sender.lastName = viewModel.sender.lastName;
        //model.sender.email = viewModel.sender.email;
        //model.sender.phone = viewModel.sender.phone;
        return model;
    }

    static validateModel(model: IRecipientsStep, workflowType: WorkflowTypeEnum): boolean {

        const emailIsRequired = model.sendBy == GiftCardSendTypeEnum.BY_EMAIL;
        const phoneIsRequired = model.sendBy == GiftCardSendTypeEnum.BY_SMS;

        // Sender
        if (!SenderDetailsModel.validateModel(model.sender)) return false;
        //if (workflowType == WorkflowTypeEnum.BUY_GIFT_CARD) {
        //    if (!SenderDetailsModel.validateModel(model.sender)) return false;
        //}

        // Scheduled Sending
        if (model.sendItLater) {
            if (!ScheduleSendDetailsModel.validateModel(model.scheduleSendDetails)) return false;
        }

        // Recipients
        if (!model.recipients || model.recipients.length == 0) return false;
        let length = model.recipients.length;
        if (model.sendIndividually == false) length = 1; //validate only first recipient

        for (var i = 0; i < length; i++) {

            if (!RecipientDetailsModel.validateModel(model.recipients[i], emailIsRequired, phoneIsRequired)) {
                return false;
            }
        }

        //else
        return true;
    }

    ////USED
    //isValid(): boolean {
    //    console.error("RecipientsStepModel.IsValid() - should not be used!");

    //    let emailIsRequired = this.sendBy == GiftCardSendTypeEnum.BY_EMAIL;
    //    let phoneIsRequired = this.sendBy == GiftCardSendTypeEnum.BY_SMS;

    //    // Sender
    //    if (!SenderDetailsModel.validateModel(this.sender)) return false;

    //    // Scheduled Sending
    //    if (this.sendItLater) {
    //        if (!ScheduleSendDetailsModel.validateModel(this.scheduleSendDetails)) return false;
    //    }

    //    // Recipients
    //    if (!this.recipients || this.recipients.length == 0) return false;
    //    for (var i = 0; i < this.recipients.length; i++) {
    //        if (!RecipientDetailsModel.validateModel(this.recipients[i], emailIsRequired, phoneIsRequired)) {
    //            return false;
    //        }
    //    }

    //    //else
    //    return true;
    //}
}